import { render, staticRenderFns } from "./WorkMessageApproval.vue?vue&type=template&id=556df93c&scoped=true"
import script from "./WorkMessageApproval.vue?vue&type=script&lang=js"
export * from "./WorkMessageApproval.vue?vue&type=script&lang=js"
import style0 from "./WorkMessageApproval.vue?vue&type=style&index=0&id=556df93c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556df93c",
  null
  
)

export default component.exports